import { globalLoggerToken } from "@/tokens";
import { inject, singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";
import { ModuleInterface } from "@interfaces/ModuleInterface";

import { DynamicImportManager } from "./DynamicImportManager";

interface DynamicImportModuleExports {
    dynamicImportManager: DynamicImportManager;
}

@singleton()
export class DynamicImportModule
    implements ModuleInterface<DynamicImportModuleExports>
{
    exports: DynamicImportModuleExports;

    constructor(
        @inject(globalLoggerToken)
        private readonly logger: LoggerInterface
    ) {
        const dynamicImportManager = new DynamicImportManager(this.logger);

        this.exports = {
            dynamicImportManager,
        };
    }

    registerProviders() {
        return {};
    }
}
